import React, { useEffect, useState } from "react";
import { Button } from "@mui/joy";
import { Project } from "../../Objects/Project";
import { htmlLabelValue, sanitizeHtml } from "../Helpers";
import DynamicEditModal from "../DynamicComponents/DynamicEditModal";
import { ApiService } from "../../api/ProjectInfoService";
import { ToastContainer, toast } from "react-toastify";
import "../AlgemeenTab/boxes.scss";

interface Props {
    title: string;
    project: Project;
    language: "nl" | "en";
    userIsPrivileged: boolean;
}

const OnderzoeksopzetBox = ({ title, project, language, userIsPrivileged }: Props) => {
    const [openEditModal, setOpenEditModal] = useState(false);
    const [values, setValues] = useState<{ label: string; value: string; lang: string }[]>([]);

    useEffect(() => {
        setValues([
            // Dutch fields
            { label: "Onderzoeksvraag (NL)", value: sanitizeHtml(project?.researchQuestionNl ?? ""), lang: "researchQuestionNl" },
            { label: "Onderzoeksmethode (NL)", value: sanitizeHtml(project?.researchMethodNl ?? ""), lang: "researchMethodNl" },
            { label: "Probleemstelling / doelstellingen (NL)", value: sanitizeHtml(project?.problemStatementObjectivesNl ?? ""), lang: "problemStatementObjectivesNl" },
            { label: "Werkpakketten (NL)", value: sanitizeHtml(project?.workpackagesNl ?? ""), lang: "workpackagesNl" },
            // English fields
            { label: "Research question (EN)", value: sanitizeHtml(project?.researchQuestionEn ?? ""), lang: "researchQuestionEn" },
            { label: "Research method (EN)", value: sanitizeHtml(project?.researchMethodEn ?? ""), lang: "researchMethodEn" },
            { label: "Problem statement / objectives (EN)", value: sanitizeHtml(project?.problemStatementObjectivesEn ?? ""), lang: "problemStatementObjectivesEn" },
            { label: "Work packages (EN)", value: sanitizeHtml(project?.workpackagesEn ?? ""), lang: "workpackagesEn" },
        ]);
    }, [project]);

    const findVal = (data: any[], lang: string, fallback: any) =>
        data.find((item: any) => item.lang === lang)?.value ?? fallback;

    const handleSave = (data: any) => {
        const mappendata = {
            projectDospId: project.dospId,
            researchQuestion_Nl: findVal(data, "researchQuestionNl", project.researchQuestionNl),
            researchQuestion_En: findVal(data, "researchQuestionEn", project.researchQuestionEn),
            researchMethod_Nl: findVal(data, "researchMethodNl", project.researchMethodNl),
            researchMethod_En: findVal(data, "researchMethodEn", project.researchMethodEn),
            problemStatementObjectives_Nl: findVal(data, "problemStatementObjectivesNl", project.problemStatementObjectivesNl),
            problemStatementObjectives_En: findVal(data, "problemStatementObjectivesEn", project.problemStatementObjectivesEn),
            workpackages_Nl: findVal(data, "workpackagesNl", project.workpackagesNl),
            workpackages_En: findVal(data, "workpackagesEn", project.workpackagesEn),
        };

        ApiService.postProject(mappendata)
            .then(() => {
                toast.success("Project succesvol aangevraagd om aan te passen");
                setOpenEditModal(false);
            })
            .catch((error: any) => {
                console.log(error);
                toast.error("Er is iets misgegaan bij het aanvragen om het project aan te passen");
            });
    };

    return (
        <>
            <div className="box">
                <h3>
                    {title}
                    {userIsPrivileged && <Button
                        className="headerButton"
                        variant="outlined"
                        color="neutral"
                        onClick={() => setOpenEditModal(true)}
                    >
                        Wijzig
                    </Button>}
                </h3>
                <div className="items">
                    <h4>Nederlands</h4>
                    {htmlLabelValue(sanitizeHtml(project?.descriptionNl ?? ""), "Samenvatting")}
                    {htmlLabelValue(sanitizeHtml(project?.researchQuestionNl ?? ""), "Onderzoeksvraag")}
                    {htmlLabelValue(sanitizeHtml(project?.researchMethodNl ?? ""), "Onderzoeksmethode")}
                    {htmlLabelValue(sanitizeHtml(project?.problemStatementObjectivesNl ?? ""), "Probleemstelling / doelstellingen")}
                    {htmlLabelValue(sanitizeHtml(project?.workpackagesNl ?? ""), "Werkpakketten")}

                    <h4>English</h4>
                    {htmlLabelValue(sanitizeHtml(project?.descriptionEn ?? ""), "Summary")}
                    {htmlLabelValue(sanitizeHtml(project?.researchQuestionEn ?? ""), "Research question")}
                    {htmlLabelValue(sanitizeHtml(project?.researchMethodEn ?? ""), "Research method")}
                    {htmlLabelValue(sanitizeHtml(project?.problemStatementObjectivesEn ?? ""), "Problem statement / objectives")}
                    {htmlLabelValue(sanitizeHtml(project?.workpackagesEn ?? ""), "Work packages")}
                </div>
            </div>
            {userIsPrivileged && <DynamicEditModal
                isOpen={openEditModal}
                onClose={() => setOpenEditModal(false)}
                onSave={handleSave}
                values={values}
            />}
            <ToastContainer />
        </>
    );
};

export default OnderzoeksopzetBox;
